var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperienceMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 235,
    viewBox: "0 0 298 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_11893)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1355_11893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4158 347C70.7704 347 100.373 339.499 126.527 326.194M111.137 -23.9551C124.927 -18.411 137.928 -11.3157 149.921 -2.88518",
    stroke: "#0C00FF",
    strokeWidth: 2.46252,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.50798,
    y: 0.870632,
    width: 172.045,
    height: 219.028,
    rx: 13.5439,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 271.261 67.8933)",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2.46252
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4299 212.809C42.4912 213.627 43.5048 215.486 44.4852 217.284C46.2474 220.515 48.245 224.178 52.1138 225.215C55.9826 226.251 59.5439 224.078 62.6857 222.161C64.4334 221.094 66.2407 219.991 67.569 219.813C69.0117 219.62 71.1246 220.223 73.1682 220.804C73.4411 220.882 73.7173 220.961 73.9954 221.039L62.6857 262.351C62.4453 263.248 61.7707 263.965 60.8895 264.26C60.0085 264.554 59.0382 264.387 58.3067 263.815L44.4382 252.964L27.0025 255.427C26.6284 255.48 26.2539 255.455 25.8994 255.36C25.3825 255.221 24.9087 254.933 24.5434 254.521C23.9277 253.825 23.7017 252.867 23.9421 251.97L35.2518 210.657C35.5316 210.729 35.81 210.799 36.0853 210.868C38.1457 211.386 40.2769 211.921 41.4299 212.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1355_11893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9158 175.312C28.3387 173.734 30.7812 172.396 33.1431 171.102C35.4448 169.842 37.8248 168.538 39.3497 166.546C40.9383 164.47 41.6063 161.763 42.2521 159.145C42.8809 156.597 43.5311 153.961 44.8191 153.214C46.1115 152.463 48.7246 153.208 51.2524 153.928C53.8413 154.666 56.5169 155.428 59.1021 155.082C61.5852 154.75 63.8981 153.338 66.1349 151.973C68.4346 150.57 70.8129 149.118 72.3904 149.541C73.9678 149.963 75.3017 152.41 76.5916 154.775C77.8463 157.076 79.1435 159.455 81.1277 160.984C83.1937 162.576 85.8919 163.254 88.5031 163.909C91.0514 164.549 93.6872 165.212 94.4315 166.507C95.173 167.799 94.4185 170.406 93.6889 172.927C92.9393 175.517 92.1642 178.196 92.502 180.788C92.8263 183.276 94.2355 185.595 95.5987 187.837C96.9973 190.139 98.4437 192.518 98.0208 194.097C97.5979 195.675 95.1556 197.013 92.7937 198.306C90.4919 199.567 88.1118 200.87 86.5869 202.863C84.9983 204.939 84.3303 207.646 83.6845 210.264C83.0557 212.812 82.4055 215.447 81.1175 216.195C79.825 216.945 77.2116 216.201 74.6844 215.481C74.1605 215.331 73.6327 215.181 73.1032 215.039C71.0162 214.48 68.8966 214.051 66.8345 214.327C64.3516 214.659 62.0387 216.07 59.8019 217.435C57.502 218.839 55.1238 220.29 53.5463 219.868C51.9688 219.445 50.6349 216.999 49.345 214.633C48.0903 212.333 46.7931 209.954 44.8089 208.425C42.7428 206.833 40.0431 206.155 37.4335 205.499C34.8853 204.859 32.2493 204.198 31.5052 202.901C30.7636 201.61 31.5182 199.002 32.2477 196.481C32.9973 193.891 33.7725 191.213 33.4346 188.621C33.1103 186.133 31.7011 183.814 30.3378 181.571C28.9391 179.27 27.4929 176.89 27.9158 175.312Z",
    fill: "url(#paint0_linear_1355_11893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8613 158.555L39.8613 158.555C39.1876 161.286 38.6141 163.455 37.3942 165.049C36.2438 166.552 34.3703 167.623 31.9602 168.943L31.8864 168.983C30.7584 169.601 29.444 170.32 28.3592 171.105C27.342 171.841 25.9856 173.001 25.5372 174.675C25.0887 176.348 25.6832 178.031 26.1962 179.177C26.7435 180.399 27.522 181.68 28.1902 182.779L28.2335 182.85L28.2335 182.85C29.6609 185.199 30.7481 187.062 30.9927 188.939C31.2522 190.93 30.6642 193.095 29.8823 195.797L29.8599 195.874C29.5112 197.079 29.1065 198.477 28.8954 199.749C28.7034 200.907 28.531 202.667 29.3696 204.127L31.5052 202.901L29.3696 204.127C30.2095 205.59 31.8172 206.329 32.9169 206.748C34.1233 207.207 35.5359 207.562 36.7529 207.867L36.8331 207.887C36.8333 207.887 36.8335 207.887 36.8337 207.887C39.5568 208.572 41.7193 209.153 43.3057 210.375C44.8036 211.53 45.8694 213.404 47.1831 215.813L47.2233 215.886C47.8392 217.016 48.557 218.332 49.3401 219.419C50.0738 220.437 51.2332 221.797 52.909 222.246C54.5848 222.695 56.2689 222.097 57.4134 221.582C58.6347 221.033 59.9145 220.252 61.0128 219.581L61.0847 219.537C63.4264 218.108 65.2865 217.018 67.1609 216.767C68.7075 216.561 70.4234 216.871 72.4659 217.418C72.9693 217.553 73.474 217.696 73.9968 217.845L74.0093 217.849L74.0101 217.849L74.0818 217.87C75.2909 218.214 76.6947 218.615 77.972 218.821C79.1338 219.008 80.8951 219.171 82.3538 218.325L81.1175 216.195L82.3538 218.325C83.8106 217.479 84.5409 215.869 84.9535 214.77C85.4069 213.563 85.7555 212.15 86.0559 210.932L86.0753 210.853L86.0753 210.853C86.749 208.123 87.3225 205.954 88.5424 204.36L39.8613 158.555ZM39.8613 158.555L39.8807 158.477M39.8613 158.555L39.8807 158.477M51.9275 151.56L51.9266 151.56L51.8422 151.535C50.6363 151.192 49.2373 150.794 47.9646 150.589C46.8033 150.401 45.0417 150.237 43.5828 151.084L51.9275 151.56ZM51.9275 151.56C54.6275 152.329 56.7905 152.907 58.7754 152.641C60.6502 152.39 62.5104 151.3 64.8521 149.871C64.8521 149.871 64.8521 149.871 64.8521 149.871L64.9244 149.827C66.0224 149.157 67.3021 148.376 68.5232 147.826C69.6677 147.312 71.3518 146.713 73.0277 147.162C74.7036 147.611 75.8629 148.972 76.5966 149.99C77.3795 151.076 78.0972 152.392 78.713 153.522L78.7535 153.596C80.0672 156.005 81.133 157.879 82.6309 159.033L82.631 159.033M51.9275 151.56L82.631 159.033M82.631 159.033C84.2173 160.256 86.3791 160.837 89.1027 161.521L89.1028 161.521M82.631 159.033L89.1028 161.521M89.1028 161.521L89.1782 161.54C90.3968 161.846 91.8116 162.201 93.0199 162.661C94.1195 163.08 95.7268 163.818 96.5668 165.281L96.5671 165.281M89.1028 161.521L96.5671 165.281M96.5671 165.281C97.4057 166.742 97.2332 168.501 97.0412 169.659C96.8302 170.932 96.4255 172.33 96.0768 173.534L96.0543 173.612L96.0543 173.612M96.5671 165.281L96.0543 173.612M96.0543 173.612C95.2724 176.314 94.6844 178.479 94.9439 180.47L96.0543 173.612ZM93.9765 200.466L93.9766 200.466L94.0497 200.426C95.1779 199.808 96.4926 199.088 97.5776 198.303C98.5947 197.568 99.951 196.408 100.399 194.734C100.848 193.06 100.253 191.377 99.7403 190.232C99.1931 189.01 98.4147 187.729 97.7467 186.63L97.703 186.558C97.703 186.558 97.703 186.558 97.703 186.558C96.2757 184.21 95.1885 182.346 94.9439 180.47L93.9765 200.466ZM93.9765 200.466C91.5665 201.786 89.693 202.856 88.5426 204.359L93.9765 200.466ZM39.8807 158.477C40.1811 157.259 40.5297 155.846 40.9831 154.638M39.8807 158.477L40.9831 154.638M40.9831 154.638C41.3957 153.54 42.126 151.93 43.5826 151.084L40.9831 154.638Z",
    stroke: "url(#paint1_linear_1355_11893)",
    strokeWidth: 4.92504
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1355_11893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1929 180.785C51.2445 173.128 59.1187 168.562 66.7461 170.606C74.3735 172.65 78.9096 180.541 76.858 188.198C74.8064 195.854 66.9322 200.421 59.3048 198.377C51.6774 196.333 47.1414 188.442 49.1929 180.785Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 55.7082,
    height: 5.36947,
    rx: 2.46252,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 207.602 95.6287)",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.0777,
    height: 5.36947,
    rx: 2.46252,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 219.314 134.9)",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.0777,
    height: 5.36947,
    rx: 2.46252,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 211.671 163.426)",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.0777,
    height: 5.36947,
    rx: 2.46252,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 204.027 191.951)",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.0777,
    height: 5.36947,
    rx: 2.46252,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 196.384 220.477)",
    fill: "#BED2F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1355_11893",
    x: 25.2563,
    y: -31.9587,
    width: 138.825,
    height: 399.274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46411
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_11893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_11893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1355_11893",
    x: 9.98828,
    y: 137.77,
    width: 105.96,
    height: 106.181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46411
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_11893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_11893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1355_11893",
    x: 35.7715,
    y: 163.346,
    width: 54.5081,
    height: 54.6035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46411
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.732258 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_11893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_11893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_11893",
    x1: 72.3903,
    y1: 149.541,
    x2: 53.5463,
    y2: 219.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1355_11893",
    x1: 72.3903,
    y1: 149.541,
    x2: 53.5463,
    y2: 219.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_11893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 235,
    fill: "white",
    transform: "matrix(-1 0 0 1 298 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceMobile);
export default __webpack_public_path__ + "static/media/experience-mobile.31604af79778ef954c5e5de87e0a3f4d.svg";
export { ForwardRef as ReactComponent };